import type { FunctionComponent, PropsWithChildren } from 'react';

interface IProps extends PropsWithChildren {
    emptyText?: boolean;
}

export const DocumentListItem: FunctionComponent<IProps> = ({ emptyText, children }) => {
    return (
        <div
            style={{
                height: '36px',
                paddingTop: 'var(--padding-top-xs)',
                borderBottom: '1px solid #C7C9D3',
                color: emptyText ? 'var(--fg-color-default-disabled)' : 'var(--fg-color-default-normal)',
                fontSize: 'var(--type-label-small-font-size)',
                lineHeight: 'var(--type-label-small-line-height)',
                fontWeight: 'var(--type-label-small-regular-font-weight)',
            }}
        >
            {children}
        </div>
    );
};
